import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import Card from "../Helpers/Card";

export default function ClientSettings(props) {
  const Api = useApi();
  const { clientId } = useParams();
  const [client, setClient] = useState(props.client);
  const [partners, setPartners] = useState(false);
  const [saveClientSuccess, setSaveClientSuccess] = useState(false);
  const [saveClientError, setSaveClientError] = useState(false);
  const [savePartnerSuccess, setSavePartnerSuccess] = useState(false);
  const [savePartnerError, setSavePartnerError] = useState(false);

  useEffect(() => {
    setClient(props.client);
    fetchPartners(); //Hämta partners
  }, [props.client])

  const fetchPartners = async () => {
    Api.get('/rolf/partners')
      .then((data) => {
        setPartners(data);
      })
      .catch((error) => {
        console.log(error);
      })
  }

  const updatePartner = async (values) => {
    setSavePartnerError(false);
    setSavePartnerSuccess(false);
    await Api.post(`/rolf/partners/${values.partnerId}/clients`, {clientId: clientId}).then(data => {
      setSavePartnerSuccess('Partner saved');
      props.refresh();
      return true;
    }).catch(e => {
      console.log(e);
      setSavePartnerError('Could not save partner');
      return false;
    }).finally(() => {
      setTimeout(() => {
        setSavePartnerError(false);
        setSavePartnerSuccess(false);
      }, 3000)
    })
  }

  //Disconnect from Partner
  function disconnectClient(setSubmitting, resetForm) {
    if(window.confirm("Are you sure you want to disconnect this client from the partner?")) {
        Api.delete(`/rolf/clients/${clientId}/partner/${client.partnerId}`)
        .then(response => {
            setSavePartnerSuccess('Client disconnected from partner');
            props.refresh();
        })
        .catch(error => {
            console.log(error);
            setSavePartnerError('Could not disconnect client from partner');
        }).finally(() => {
          setSubmitting(false);
          setTimeout(() => {
            setSavePartnerError(false);
            setSavePartnerSuccess(false);
          }, 3000)
        })
    } else {
        setSubmitting(false);
        resetForm();
    }
  }

  const saveClient = async (values) => {
    setSaveClientError(false);
    setSaveClientSuccess(false);
    await Api.put(`/rolf/clients/${clientId}`, values).then(data => {
      setSaveClientSuccess('Client saved');

      return true;
    }).catch(e => {
      setSaveClientError(e.error);
      return false;
    }).finally(() => {
      props.refresh();
      setTimeout(() => {
        setSaveClientError(false);
        setSaveClientSuccess(false);
      }, 3000)
    })
  }



  if (!client)
    return <ActivityIndicator color="black" />


  return (
    <>
      <div className="grid-container">
        <section>
          <h4>Information</h4>
          <Card>
            <Formik
              initialValues={{ ...client, modules: client.modules.split(',').map(m => m) }}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                saveClient(values).then(() => {
                  setSubmitting(false);
                })
              }}>

              {({ isSubmitting, values }) => (
                <Form>
                  <label htmlFor="name">Name</label>
                  <Field type="text" name="name" id="name" className="formControl" required />

                  <label htmlFor="description">Description</label>
                  <Field as="textarea" name="description" id="description" className="formControl" />

                  <label htmlFor="orgNr">Orgnr</label>
                  <Field type="text" name="orgNr" id="orgNr" className="formControl" required />

                  <label htmlFor="active">Active</label>
                  <Field as="select" name="active" id="active" className="formControl">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </Field>

                  <label htmlFor="paying">Paying customer</label>
                  <Field as="select" name="paying" id="paying" className="formControl">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </Field>

                  <label htmlFor="comment">Comment</label>
                  <Field as="textarea" name="comment" id="comment" className="formControl" />


                  <label htmlFor="modules">Modules</label>
                  <label className="checkbox formControl">
                    <Field type="checkbox" name="modules" value="reflection" /> Reflection
                  </label>
                  <label className="checkbox formControl">
                    <Field type="checkbox" name="modules" value="development" /> Development plan
                  </label>
                  <label className="checkbox formControl">
                    <Field type="checkbox" name="modules" value="rolfing" /> Rolfing
                  </label>
                  <label className="checkbox formControl">
                    <Field type="checkbox" name="modules" value="actionplan" /> Action plan
                  </label>
                  <label className="checkbox formControl">
                    <Field type="checkbox" name="modules" value="pulse" /> Pulse
                  </label>

                  <label htmlFor="otpOverSms" title="Whether the client can receive OTPs via SMS">OTP via SMS</label>
                  <Field as="select" name="otpOverSms" id="otpOverSms" className="formControl">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </Field>

                  {saveClientSuccess && <div className="formControlSuccess">{saveClientSuccess}</div>}
                  {saveClientError && <div className="formControlError">{saveClientError}</div>}
                  <button type="submit" disabled={isSubmitting}>Save client {isSubmitting && <ActivityIndicator />}</button>


                </Form>
              )}

            </Formik>
          </Card>
          <h4>Connect to partner</h4>
          <Card>
            {savePartnerSuccess && <div className="formControlSuccess">{savePartnerSuccess}</div>}
            {savePartnerError && <div className="formControlError">{savePartnerError}</div>}
            <Formik
              initialValues={{ partnerId: client.partnerId }}
              enableReinitialize={true}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                if(values.partnerId == 0) {
                  disconnectClient(setSubmitting, resetForm);
                  return;
                }

                updatePartner(values)
                .then(() => {
                  fetchPartners();
                }).finally(() => {
                  setSubmitting(false);
                  setTimeout(() => {
                    setSavePartnerError(false);
                    setSavePartnerSuccess(false);
                  }, 3000);
                })
              }}
            >
              {({ isSubmitting, values }) => (
              <Form>
                <label htmlFor="partnerId">Partner</label>
                <Field as="select" id="partnerId" name="partnerId" className="formControl">
                  <option value={0}>No partner</option>
                  {partners && partners.map((partner) => {
                    return (<option key={partner.ID} value={Number(partner.ID)} >{partner.name}</option>);
                  }
                  )}
                </Field>
                <button type="submit" disabled={isSubmitting}>Save partner {isSubmitting && <ActivityIndicator />}</button>
              </Form>
              )}
            </Formik>
          </Card>

        </section>
      </div>
    </>
  )
}